import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import qs from 'qs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ReactComponent as IconPdfWhite } from '../Img/icon-pdf-white.svg';
import { ReactComponent as IconScrollUp } from '../Img/scroll-up.svg';
import { Page, Text, View, Document, PDFViewer } from '@react-pdf/renderer';
import Navbar from "../components/Navbar.js";
import Access from "../components/Access.js";
import Page1Accueil from './Page1Accueil';
import Page2DonneesGenerales from './Page2DonneesGenerales';
import Page3Reponsables from './Page3Reponsables';
import Page4Pilotages from './Page4Pilotages';
import Page5IncidencesFinancieresHypPart1 from './Page5IncidencesFinancieresHypPart1';
import Page5IncidencesFinancieresHypPart2 from './Page5IncidencesFinancieresHypPart2';
import Page6GanttGlobal from './Page6GanttGlobal';
import Page7GraphsParHypothese from './Page7GraphsParHypothese';
import Logo from '../Img/Logo_projets&finances.png';
import BounceLoader from 'react-spinners/BounceLoader';

const SyntheseOperations = (props) => {
    const blue = '#069BD3';
    const green = '#59B44A';
    const purple = '#6571FE';

    const [aff, setAff] = useState(false);
    const [affPDF, setAffPDF] = useState(false);
    const [affBounceLoader, setAffBounceLoader] = useState(false);
    const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
    const [marge, setMarge] = useState(0);
    const date = new Date();
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
    const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    const dateFR = 'Le  ' + day + ' / ' + month + ' / ' + date.getFullYear() + ' à ' + hour + ':' + minutes;
    
    const [logo, setLogo] = useState(null);
    const [operations, setOperations] = useState(null);
    const [liste_operations, setListe_operations] = useState(null);
    const width = (window.innerWidth * 0.8) || 0;
    const height = (width * (210 / 297)) || 0;
    const [countPages, setCountPages] = useState(0);
    const [showButtonScrollUp, setShowButtonScrollUp] = useState(false);
    const fontsize = (Math.round(height * 12 / 890 * 100) / 100) || 12;
    
    // Hypothèses sélectionnées
    const [selectedHypotheses, setSelectedHypotheses] = useState({
        h1: true,
        h2: true,
        h3: true
    });

    async function mount()
    {
        // Récupération du logo de l'organisme
        const params = {
            'getOrganismes': true,
            'id': props.user.id_organisme
        }
        
        await axios.post('https://app-slfinance.fr/api/organismes.php', qs.stringify(params))
        .then(async (res) => {
            await setLogo(res.data[0].logo);
        })
        .catch((err) => {
            console.warn(err)
        })

        // Récupération des opérations du budget
        const params_operations = {
            'get': true,
            'id_budget': props.user.id_budget
        }
        await axios.post('https://app-slfinance.fr/api/operations.php', qs.stringify(params_operations))
        .then(async (res) => {
            const operationsData = res.data.data || res.data;
            
            // Récupération des pilotages pour chaque opération
            if (operationsData && operationsData.length > 0) {
                const pilotagePromises = operationsData.map(operation => {
                    const params_pilotage = {
                        'get': true,
                        'id_operation': operation.id
                    }
                    return axios.post('https://app-slfinance.fr/api/pilotage_projet.php', qs.stringify(params_pilotage))
                        .then(res => {
                            if (res.data && res.data.length > 0) {
                                // Prendre le dernier pilotage (ordre desc par date)
                                const lastPilotage = res.data[res.data.length - 1];
                                return {
                                    ...operation,
                                    pilotage_date: lastPilotage[3] || null,  // index 3 = date
                                    pilotage_decision: lastPilotage[5] || null,  // index 5 = releve_decision
                                    pilotage_date_limite: lastPilotage[7] || null,  // index 7 = date_limite_action
                                    pilotage_action_suivante: lastPilotage[6] || null  // index 6 = action_suivante
                                }
                            }
                            return operation;
                        })
                        .catch(err => {
                            console.warn('Erreur pilotage opération:', operation.id, err);
                            return operation;
                        })
                });
                
                const operationsWithPilotage = await Promise.all(pilotagePromises);
                await setListe_operations(operationsWithPilotage);
            } else {
                await setListe_operations(operationsData);
            }
        })
        .catch((err) => {
            console.warn('Erreur chargement opérations:', err)
        })
    }

    // ici useEffect pour recuperer les operations du budget, le logo du budget
    useEffect(() => {
        if (props.user === null) {
            props.getUser();
        }
        else {
            mount();
        }
    }, [props.user]);

    // useEffect pour tracker le scroll et afficher le bouton scroll-up
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 500) {
                setShowButtonScrollUp(true);
            } else {
                setShowButtonScrollUp(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Calculer le nombre de pages total
    useEffect(() => {
        if (liste_operations && liste_operations.length > 0) {
            const groupsOf7 = Math.ceil(liste_operations.length / 7);
            let totalPages = 1; // Page 1 : Accueil

            // Pages 2, 3, 4 : groupes de 7
            totalPages += groupsOf7 * 3;

            // Pages 5 : Incidences Financières (Part 1 et Part 2) répétées pour chaque hypothèse sélectionnée
            const selectedCount = Object.values(selectedHypotheses).filter(v => v).length;
            totalPages += selectedCount * 2;

            // Page 6 : Gantt Global
            totalPages += 1;

            // Pages 7 : Graphiques par Hypothèse (une page par hypothèse sélectionnée)
            totalPages += selectedCount;

            setCountPages(totalPages);
            setAff(true); // Afficher la prévisualisation
        }
    }, [liste_operations, selectedHypotheses]);

    const generateAndDownloadPDF = async () => {
        try {
            setIsGeneratingPDF(true);
            setMarge(10);
            
            // Créer un PDF paysage
            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4'
            });

            // Récupérer tous les divs avec value='PDF'
            const pdfDivs = document.querySelectorAll("div[value='PDF']");
            
            if (pdfDivs.length === 0) {
                alert('Aucune page PDF trouvée');
                setIsGeneratingPDF(false);
                return;
            }

            // Convertir chaque div en image et l'ajouter au PDF
            for (let i = 0; i < pdfDivs.length; i++) {
                console.log(`Conversion de la page ${i + 1}/${pdfDivs.length}...`);
                
                // Convertir le div en canvas avec une meilleure résolution
                const canvas = await html2canvas(pdfDivs[i], {
                    scale: 2,
                    useCORS: true,
                    allowTaint: true,
                    backgroundColor: '#ffffff',
                    logging: false
                });

                // Créer une image à partir du canvas
                const imgData = canvas.toDataURL('image/jpeg', 0.95);
                
                // Ajouter une nouvelle page au PDF (sauf pour la première)
                if (i > 0) {
                    pdf.addPage();
                }

                // Ajouter l'image à la page en remplissant toute la surface
                const pageWidth = pdf.internal.pageSize.getWidth();
                const pageHeight = pdf.internal.pageSize.getHeight();
                
                // Calculer les proportions pour que l'image rentre parfaitement
                const imgRatio = canvas.width / canvas.height;
                const pageRatio = pageWidth / pageHeight;
                
                let finalWidth = pageWidth;
                let finalHeight = pageHeight;
                
                if (imgRatio > pageRatio) {
                    finalHeight = pageWidth / imgRatio;
                } else {
                    finalWidth = pageHeight * imgRatio;
                }
                
                const xOffset = (pageWidth - finalWidth) / 2;
                const yOffset = (pageHeight - finalHeight) / 2;
                
                pdf.addImage(imgData, 'JPEG', xOffset, yOffset, finalWidth, finalHeight);
            }

            // Télécharger le PDF
            pdf.save('Synthese_Operations.pdf');
            console.log('PDF créé avec succès');
            setMarge(0);
            setIsGeneratingPDF(false);
        } catch (error) {
            console.error('Erreur:', error);
            alert('Erreur lors de la création du PDF');
            setMarge(0);
            setIsGeneratingPDF(false);
        }
    };

    return (
        <div style={{position: 'relative'}}>
            <Access needConnection={true} type_user={[0]}>
                <Navbar user={props.user} />

                {showButtonScrollUp && affPDF === false && (
                    <button
                        style={{position: 'fixed', bottom: 20, right: 20, width: (width/10), height: (height/10), border: '1px solid black', borderRadius: 5}}
                        onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
                    >
                        <IconScrollUp width={(width/10)}/>
                    </button>
                )}
                
                {affPDF === false && (
                    <div style={{display: 'flex'}}>
                        <div style={{flex: 1, margin: 20, display: 'flex'}}>
                            <div style={{flex: 1, display: 'flex'}}>
                                <p>Opérations</p>
                                <p style={{marginLeft: 5}}>\</p>
                                <p style={{marginLeft: 5, color: purple, fontWeight: 'bold'}}>Édition de la synthèse</p>
                            </div>
                            <div style={{flex: 1}}>
                                {props.user?
                                    <p style={{flex: 1, textAlign: 'center'}}>{props.user.nom_budget}</p>
                                    :null}
                            </div>
                            <div style={{flex: 1}}></div>
                        </div>
                    </div>
                )}

                <div style={{flex: 1}}>
                    {affPDF === false?
                        <div style={{display: 'flex'}}>
                            <div style={{flex: 1}}></div>

                            <div style={{flex: 1, marginTop: 20, textAlign: 'center'}}>
                                <p style={{color: purple, fontSize: 20}}>Prévisualisation</p>

                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap'}}>
                                    <button
                                        className='shadow-md rounded-md'
                                        style={
                                            selectedHypotheses.h1?
                                            {backgroundColor: purple, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                                            :
                                            {color: purple, fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                                        }
                                        onClick={() => {
                                            setSelectedHypotheses({...selectedHypotheses, h1: !selectedHypotheses.h1});
                                        }}
                                    >
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <p style={{margin: 5}}>Hypothèse 1</p>
                                        </div>
                                    </button>

                                    <button
                                        className='shadow-md rounded-md'
                                        style={
                                            selectedHypotheses.h2?
                                            {backgroundColor: purple, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                                            :
                                            {color: purple, fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                                        }
                                        onClick={() => {
                                            setSelectedHypotheses({...selectedHypotheses, h2: !selectedHypotheses.h2});
                                        }}
                                    >
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <p style={{margin: 5}}>Hypothèse 2</p>
                                        </div>
                                    </button>

                                    <button
                                        className='shadow-md rounded-md'
                                        style={
                                            selectedHypotheses.h3?
                                            {backgroundColor: purple, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                                            :
                                            {color: purple, fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                                        }
                                        onClick={() => {
                                            setSelectedHypotheses({...selectedHypotheses, h3: !selectedHypotheses.h3});
                                        }}
                                    >
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <p style={{margin: 5}}>Hypothèse 3</p>
                                        </div>
                                    </button>
                                </div>
                            </div>

                            <div style={{flex: 1, display: 'flex'}}>
                                <div style={{flex: 1}}></div>
                                <div style={{flex: 0.5}}>
                                    <button
                                        className='shadow-md rounded-md'
                                        style={{backgroundColor: green, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}}
                                        onClick={generateAndDownloadPDF}
                                    >
                                        {isGeneratingPDF === false?
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                <IconPdfWhite width="18"/>
                                                <p style={{margin: 5}}>Créer le PDF</p>
                                            </div>
                                            :
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                <BounceLoader size={20} color='white' />
                                                <p style={{margin: 5}}>Création en cours...</p>
                                            </div>
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    :null}
                    
                    {aff && liste_operations && affPDF === false && (
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 20, gap: 20}}>
                            {/* PAGE 1 */}
                            
                            <div
                                value='PDF'
                                className="page-synthese-operations"
                                style={{
                                    width: width,
                                    height: height,
                                    backgroundColor: 'white',
                                    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                                    padding: 20,
                                    boxSizing: 'border-box'
                                }}
                            >
                                <Page1Accueil
                                    logo={logo}
                                    user={props.user}
                                    date={dateFR}
                                    pagination="1"
                                    countPageTotal={countPages}
                                    height={height}
                                    width={width}
                                    marge={marge}
                                />
                            </div>
                           

                            {/* PAGE 2 */}
                            
                            {liste_operations && (() => {
                                const groupsOf7 = Math.ceil(liste_operations.length / 9);
                                const pages = [];
                                let pageNum = 2;

                                for (let group = 0; group < groupsOf7; group++) {
                                    const start = group * 9;
                                    const end = Math.min(start + 9, liste_operations.length);
                                    const opsForGroup = liste_operations.slice(start, end);

                                    pages.push(
                                        <div
                                            key={`page2-${group}`}
                                            value='PDF'
                                            className="page-synthese-operations"
                                            style={{
                                                width: width,
                                                height: height,
                                                backgroundColor: 'white',
                                                boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                                                padding: 20,
                                                boxSizing: 'border-box',
                                                marginTop: 20
                                            }}
                                        >
                                            <Page2DonneesGenerales
                                                operations={opsForGroup}
                                                logo={logo}
                                                user={props.user}
                                                date={dateFR}
                                                pagination={pageNum.toString()}
                                                countPageTotal={countPages}
                                                height={height}
                                                width={width}
                                                marge={marge}
                                                index={group + 1}
                                                indexTotal={groupsOf7}
                                            />
                                        </div>
                                    );
                                    pageNum++;
                                }

                                return pages;
                            })()}
                           

                            {/* PAGE 3 */}
                            
                            {liste_operations && (() => {
                                const groupsOf7 = Math.ceil(liste_operations.length / 9);
                                const pages = [];
                                let pageNum = 2 + groupsOf7;

                                for (let group = 0; group < groupsOf7; group++) {
                                    const start = group * 9;
                                    const end = Math.min(start + 9, liste_operations.length);
                                    const opsForGroup = liste_operations.slice(start, end);

                                    pages.push(
                                        <div
                                            key={`page3-${group}`}
                                            value='PDF'
                                            className="page-synthese-operations"
                                            style={{
                                                width: width,
                                                height: height,
                                                backgroundColor: 'white',
                                                boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                                                padding: 20,
                                                boxSizing: 'border-box',
                                                marginTop: 20
                                            }}
                                        >
                                            <Page3Reponsables
                                                operations={opsForGroup}
                                                logo={logo}
                                                user={props.user}
                                                date={dateFR}
                                                pagination={pageNum.toString()}
                                                countPageTotal={countPages}
                                                height={height}
                                                width={width}
                                                marge={marge}
                                                index={group + 1}
                                                indexTotal={groupsOf7}
                                            />
                                        </div>
                                    );
                                    pageNum++;
                                }

                                return pages;
                            })()}
                           

                            {/* PAGE 4 */}
                            
                            {liste_operations && (() => {
                                const groupsOf7 = Math.ceil(liste_operations.length / 9);
                                const pages = [];
                                let pageNum = 2 + (groupsOf7 * 2);

                                for (let group = 0; group < groupsOf7; group++) {
                                    const start = group * 9;
                                    const end = Math.min(start + 9, liste_operations.length);
                                    const opsForGroup = liste_operations.slice(start, end);

                                    pages.push(
                                        <div
                                            key={`page4-${group}`}
                                            value='PDF'
                                            className="page-synthese-operations"
                                            style={{
                                                width: width,
                                                height: height,
                                                backgroundColor: 'white',
                                                boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                                                padding: 20,
                                                boxSizing: 'border-box',
                                                marginTop: 20
                                            }}
                                        >
                                            <Page4Pilotages
                                                operations={opsForGroup}
                                                logo={logo}
                                                user={props.user}
                                                date={dateFR}
                                                pagination={pageNum.toString()}
                                                countPageTotal={countPages}
                                                height={height}
                                                width={width}
                                                marge={marge}
                                                index={group + 1}
                                                indexTotal={groupsOf7}
                                            />
                                        </div>
                                    );
                                    pageNum++;
                                }

                                return pages;
                            })()}
                           
                            
                            {/* PAGE 5 */}
                            
                            {(() => {
                                const pages = [];
                                let pageNum = 2 + (Math.ceil(liste_operations.length / 7) * 3);
                                const hypotheses = [
                                    { key: 'h1', num: 1 },
                                    { key: 'h2', num: 2 },
                                    { key: 'h3', num: 3 }
                                ];

                                hypotheses.forEach((hyp) => {
                                    if (selectedHypotheses[hyp.key]) {
                                        // Part 1
                                        pages.push(
                                            <div
                                                key={`page5-part1-${hyp.key}`}
                                                value='PDF'
                                                className="page-synthese-operations"
                                                style={{
                                                    width: width,
                                                    height: height,
                                                    backgroundColor: 'white',
                                                    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                                                    padding: 20,
                                                    boxSizing: 'border-box',
                                                    marginTop: 20
                                                }}
                                            >
                                                <Page5IncidencesFinancieresHypPart1
                                                    logo={logo}
                                                    user={props.user}
                                                    date={dateFR}
                                                    pagination={pageNum.toString()}
                                                    countPageTotal={countPages}
                                                    height={height}
                                                    width={width}
                                                    marge={marge}
                                                    hypothese={hyp.num}
                                                />
                                            </div>
                                        );
                                        pageNum++;

                                        // Part 2
                                        pages.push(
                                            <div
                                                key={`page5-part2-${hyp.key}`}
                                                value='PDF'
                                                className="page-synthese-operations"
                                                style={{
                                                    width: width,
                                                    height: height,
                                                    backgroundColor: 'white',
                                                    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                                                    padding: 20,
                                                    boxSizing: 'border-box',
                                                    marginTop: 20
                                                }}
                                            >
                                                <Page5IncidencesFinancieresHypPart2
                                                    logo={logo}
                                                    user={props.user}
                                                    date={dateFR}
                                                    pagination={pageNum.toString()}
                                                    countPageTotal={countPages}
                                                    height={height}
                                                    width={width}
                                                    marge={marge}
                                                    hypothese={hyp.num}
                                                />
                                            </div>
                                        );
                                        pageNum++;
                                    }
                                });

                                return pages;
                            })()}
                           
                            
                            {/* PAGE 6 */}
                            
                            <div
                                value='PDF'
                                className="page-synthese-operations"
                                style={{
                                    width: width,
                                    height: height,
                                    backgroundColor: 'white',
                                    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                                    padding: 20,
                                    boxSizing: 'border-box',
                                    marginTop: 20
                                }}
                            >
                                <Page6GanttGlobal
                                    logo={logo}
                                    user={props.user}
                                    date={dateFR}
                                    pagination={(2 + (Math.ceil(liste_operations.length / 7) * 3) + (Object.values(selectedHypotheses).filter(v => v).length * 2)).toString()}
                                    countPageTotal={countPages}
                                    height={height}
                                    width={width}
                                    marge={marge}
                                    operations={liste_operations}
                                />
                            </div>
                           
                            
                            {/* Page 7 : Graphiques par Hypothèse */}
                            {(() => {
                                const pages = [];
                                let pageNum = 2 + (Math.ceil(liste_operations.length / 7) * 3) + (Object.values(selectedHypotheses).filter(v => v).length * 2) + 1;
                                const hypotheses = [
                                    { key: 'h1', num: 1 },
                                    { key: 'h2', num: 2 },
                                    { key: 'h3', num: 3 }
                                ];

                                hypotheses.forEach((hyp) => {
                                    if (selectedHypotheses[hyp.key]) {
                                        pages.push(
                                            <div
                                                key={`page7-${hyp.key}`}
                                                value='PDF'
                                                className="page-synthese-operations"
                                                style={{
                                                    width: width,
                                                    height: height,
                                                    backgroundColor: 'white',
                                                    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                                                    padding: 20,
                                                    boxSizing: 'border-box',
                                                    marginTop: 20
                                                }}
                                            >
                                                <Page7GraphsParHypothese
                                                    logo={logo}
                                                    user={props.user}
                                                    date={dateFR}
                                                    pagination={pageNum.toString()}
                                                    countPageTotal={countPages}
                                                    height={height}
                                                    width={width}
                                                    marge={marge}
                                                    hypothese={hyp.num}
                                                />
                                            </div>
                                        );
                                        pageNum++;
                                    }
                                });

                                return pages;
                            })()}
                            
                        </div>
                    )}
                </div>
            </Access>
        </div>
    );
};

export default SyntheseOperations;
